import { Navigate } from "react-router-dom";
import LoginPage from "../_pages/LoginPage";

const PublicRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <LoginPage />,
  }
];

export default PublicRoutes;
